// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleByline_root__tG6xW","link":"ArticleByline_link__1aQm_"};